import React from 'react';
import { programs } from '../../data/programs';
import { usePrograms } from '../../contexts/ProgramContext';
import { scrollToId } from '../../utils/scroll';
import { Container } from '../ui/Container';
import { Reveal } from '../ui/Reveal';
import { SectionTitle } from '../ui/SectionTitle';
import { ProgramCard } from './ProgramCard';
import { ProgramDetail } from './ProgramDetail';
export function Programs() {
  const {
    activeId,
    setActiveId
  } = usePrograms();
  return <section id="programs" aria-labelledby="programs-title" className="bg-paper py-20 lg:py-28" data-id="element-189" data-mp="wvdpspmr1ly5">
      <Container data-id="element-190" data-mp="11v02mxyo106f">
        <Reveal className="grid gap-6 lg:grid-cols-12 lg:items-end" data-id="element-191" data-mp="11ugjjdxa45qt">
          <SectionTitle id="programs-title" className="lg:col-span-7" data-id="element-192" data-mp="16lgfafunwhrq">
            Find the right class for your family
          </SectionTitle>
          <p className="text-pretty text-[1.05rem] leading-relaxed text-muted lg:col-span-5 lg:pb-2" data-id="element-193" data-mp="94zxcy095l31">
            Every program teaches Olympic-style Taekwondo, shaped for the age and goals of the student. Choose a program
            to see what classes practice and who it suits.
          </p>
        </Reveal>

        <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4" data-id="element-194" data-mp="20ya93fznfpcn">
          {programs.map(program => <li key={program.id} data-id="element-195" data-mp="1w58sn3jsnhqy">
              <ProgramCard program={program} selected={activeId === program.id} onSelect={() => {
            setActiveId(program.id);
            requestAnimationFrame(() => scrollToId('program-detail', true));
          }} data-id="element-196" data-mp="1r88j2inqjwv3" />
            </li>)}
        </ul>

        <ProgramDetail data-id="element-197" data-mp="1d8po6rjxqi0q" />
      </Container>
    </section>;
}